module.exports = __webpack_public_path__ + "static/media/silver_350_350.53f6751d.png";